import { SET_IS_DR_ENABLED } from '../actions/types';

const initialState = false;

export default function isDREnabled(state = initialState, action) {
	switch (action.type) {
		case SET_IS_DR_ENABLED:
			return action.payload;
		default:
			return state;
	}
}
